import { AlertIcon } from '@movingimage-evp/mi-ui-component-library';
import { Trans } from 'react-i18next';

import styles from './error-message.module.css';

export function ErrorMessage({ action }: { action: 'retry' | 'switch' | 'stop' }) {
  return (
    <div className={styles.wrapper} data-testid="player-error-wrapper">
      <AlertIcon style={{ width: '48px', height: '48px' }} />
      <Trans i18nKey={`viewer.views.stream.errors.${action}`} />
    </div>
  );
}
